<template>
  <div>
    <div class="pub-wrap">
      <ul class="pub-t pub-process process-5 pub-process-flex">
        <li class="active"><span class="ball">提交入会申请</span></li>
        <li class="active"><span class="ball">{{stageTwo}}</span></li>
        <li :class="{'active':statusInfo.explanation===1||statusInfo.explanation===-4||statusInfo.explanation===4}"><span class="ball">{{stageThr}}</span></li>
        <li :class="{'active':statusInfo.explanation===4}"><span class="ball">{{stageFou}}</span></li>
        <li><span class="ball">成为学员</span></li>
      </ul>
      <ul class="pub-process process-5 pub-process-flex">
        <li class="active"><span class="ball"></span></li>
        <li class="active"><span class="ball"></span></li>
        <li :class="{'active':statusInfo.explanation===1||statusInfo.explanation===-4||statusInfo.explanation===4}"><span class="ball"></span></li>
        <li :class="{'active':statusInfo.explanation===4}"><span class="ball"></span></li>
        <li><span class="ball"></span></li>
      </ul>
      <p class="markInfo" v-if="this.statusInfo.explanation===4">
        恭喜您通过 TGO 鲲鹏会学员面试，点此查看
        <span class="markInfo-word-decoration">
          <b @click="$emit('submit')">付款方式</b>
          <hr>
        </span>。
      </p>
      <p class="markInfo" v-if="this.statusInfo.explanation===-1">
        很遗憾，初审未通过。您可在下方修改信息后
        <span class="markInfo-word-decoration">
          <b @click="reAudit">重新提交审核</b>
          <hr>
        </span>。
      </p>
      <p class="markInfo" v-html="warnInfo" v-else></p>
    </div>
  </div>
</template>
<script>
import service from '@/service'
export default {
  data () {
    return {}
  },
  props: ['statusInfo'],
  methods: {
    reAudit () {
      service.reAudit().then(() => this.$emit('submit', 'reAudit')).catch((err) => { console.log(err) })
    }
  },
  computed: {
    stageTwo () {
      if (this.statusInfo.explanation === -1) {
        return '初审未通过'
      } else if (this.statusInfo.explanation === 0) {
        return '待审核'
      } else {
        return '初审'
      }
    },
    stageThr () {
      if (this.statusInfo.explanation === 1) {
        return '待面试'
      } else if (this.statusInfo.explanation === -4) {
        return '面试未通过'
      } else {
        return '面试'
      }
    },
    stageFou () {
      if (this.statusInfo.explanation === 4) {
        return '待交费'
      } else {
        return '交费'
      }
    },
    warnInfo () {
      if (this.statusInfo.explanation === 0) return '信息已提交至运营团队审核，1-2个工作日给您具体回复。'
      if (this.statusInfo.explanation === 1) return '初审已通过，工作人员将在1-2个工作日与您联系。'
      if (this.statusInfo.explanation === -4) {
        return '很遗憾，您未能通过 TGO 鲲鹏会学员面试。'
      } else {
        return ''
      }
    }
  }
}
</script>
<style scoped lang='scss'>

$primary2: #be9d65;

.pub-wrap {
  position: relative;
  padding: 0 80px 10px 36px;
  // margin-top: 28px;
  border-radius: 6px;
  // background-color: #edf2f2;
  overflow: hidden;
}

.pub-process {
  position: relative;
  height: 44px;
  // margin-top: 28px;
  margin-left: 44px;
  // font-size: 0;
  color: #fff;
}

.pub-t {
  height: 30px;
}

.pub-process li {
  position: relative;
  z-index: 5;
  display: inline-block;
  width: 25%;
  height: 44px;
  // font-size: 16px;
}

.pub-t li {
  height: 30px;
  // font-size: 16px;
}

// 线相关

.pub-process li + li:after {
  position: absolute;
  top: 50%;
  left: -5px;
  z-index: 6;
  width: calc(100% - 44*1.172px);
  height: 1px;
  content: "";
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  background-color: #be9d65;
  opacity: 0.3;
}

.pub-t li + li:after {
  display: none;
}

// 线相关
.pub-process .active + .active:after {
  background-color: #be9d65;
  opacity: 1;
}

.pub-process li:first-child {
  width: 44px;
  margin-left: -44px;
}

// 球相关

.pub-process .ball {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 7;
  width: 44 * 1.472px;
  height: 44px;
  line-height: 44px;
  content: '';
  text-align: center;
  border-radius: 50%;
  background: center center no-repeat;
  background-size: contain;
  opacity: 0.3;
  // border: 2px solid #be9d6523;
}

.pub-process {
  li:first-child {
    .ball {
      background-position: center right;
      background-image: url('../assets/img/1.png');
    }
  }
  li:nth-child(2) {
    .ball {
      background-image: url('../assets/img/2.png');
    }
  }
  li:nth-child(3) {
    .ball {
      background-image: url('../assets/img/3.png');
    }
  }
  li:nth-child(4) {
    .ball {
      background-image: url('../assets/img/4.png');
    }
  }
  li:last-child {
    .ball {
      background-position: center left;
      background-image: url('../assets/img/5.png');
    }
  }
}

.pub-t {
  li {
    .ball {
      height: 30px;
      border: none;
      color: #be9d65;
      width: 100%;
      line-height: 30px;
      transform: translateX(calc(50% - 44 * 1.472px / 2));
      background: transparent;
      background-image: none !important;
    }
  }
}

.pub-process .active .ball {
  // background-color: #11c2c2;
  // background: transparent;
  // border: 2px solid #be9d65;
  opacity: 1;
}

.pub-t .active .ball {
  // background-color: #11c2c2;
  border: none;
}

.pub-process-flex {
  display: -webkit-box;
}
.pub-process-flex li {
  display: list-item;
  -webkit-box-flex: 1;
  width: auto;
}
.pub-process-flex li:first-child {
  width: 44px;
  margin-left: -44px;
  -webkit-box-flex: 0;
}

.process-3 li {
  width: 50%;
}

.process-5 li {
  width: 25%;
}

.pub-t {
  margin-bottom: 10px;
}

.pub-t li.active .ball {
  background: transparent;
  color: #be9d65;
}

.pub-t:after {
  display: none;
}

.pub-t li.active::after {
  display: none;
}

.pub-t li:first-child .ball{
  width: 120px;
}

.markInfo {
  text-align: center;
  color: #be9d65;
  margin-top: 25px;
}

.markInfo-word-decoration {
  display: inline-block;
  cursor: pointer;
  hr {
    margin: 0;
    margin-top: -3px;
    background-color: $primary2;
  }
}

</style>
